<template>
    <div>
        <el-page-header @back="goBack" content="模块类型" v-if="device.name"></el-page-header>
        <h3 style="margin-top: 0px;" v-else>模块类型</h3>
        <div class="divCon" v-if="device.name">设备：{{device.name}}</div>
        <div class="divCon">
            <el-input placeholder="搜索" v-model="search"
                      @keyup.enter.native="resetEvent">
                <el-button slot="append" icon="el-icon-search" @click="resetEvent"></el-button>
            </el-input>
        </div>
        <type-tags :tags="types" @chooseCallback="chooseCallback"/>
        <module-instance-list ref="child" v-if="moduleType"
                              :search="search" :device="device.id" :moduleType="moduleType"/>
    </div>
</template>

<script>
import TypeTags from './common/TypeTags.vue'
import ModuleInstanceList from './common/ModuleInstanceList.vue'
export default {
    name: 'ModuleType',
    components: { TypeTags, ModuleInstanceList },
    data: vm =>({
        device: {}, //设备信息
        search: '',
        types: [], //模块类型
        list: [],
        moduleType: '', //当前选择的模块类型
    }),
    created(){
        let params = this.$route.params;
        if(params.moduleStat && params.moduleStat.length > 0){
            this.renderModule(params.moduleStat)
        }
        if(params.device){
            this.device = params.device
        }
        console.log(params)
    },
    methods: {
        renderModule(moduleType){
            let _this = this;
            moduleType.forEach(m => {
                _this.types.push({
                    name: m,
                    selected: false
                })
            })
        },
        goBack(){
            this.$router.go(-1)
        },
      resetEvent(){
        this.$refs.child.resetPage();
      },
        // 根据模块类型获取模块实例
        chooseCallback(type){
            console.log(type);
            this.moduleType = '';
            setTimeout(()=>{
                this.moduleType = type
            },100)
        }
    }
}
</script>
<style scoped>
.divCon{
    width: 40%;
    margin: 20px 0px;
}
</style>
